/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SelectQuoteInput
 */
export interface SelectQuoteInput {
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteInput
   */
  shouldSendCancelPickupEmail: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteInput
   */
  shouldBookNewPickup: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteInput
   */
  shouldUpdateCustomerBilling: boolean;
  /**
   *
   * @type {string}
   * @memberof SelectQuoteInput
   */
  visibilityReason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteInput
   */
  confirmedWithCarrier: boolean;
}

/**
 * Check if a given object implements the SelectQuoteInput interface.
 */
export function instanceOfSelectQuoteInput(
  value: object,
): value is SelectQuoteInput {
  if (
    !("shouldSendCancelPickupEmail" in value) ||
    value["shouldSendCancelPickupEmail"] === undefined
  )
    return false;
  if (
    !("shouldBookNewPickup" in value) ||
    value["shouldBookNewPickup"] === undefined
  )
    return false;
  if (
    !("shouldUpdateCustomerBilling" in value) ||
    value["shouldUpdateCustomerBilling"] === undefined
  )
    return false;
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  return true;
}

export function SelectQuoteInputFromJSON(json: any): SelectQuoteInput {
  return SelectQuoteInputFromJSONTyped(json, false);
}

export function SelectQuoteInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SelectQuoteInput {
  if (json == null) {
    return json;
  }
  return {
    shouldSendCancelPickupEmail: json["shouldSendCancelPickupEmail"],
    shouldBookNewPickup: json["shouldBookNewPickup"],
    shouldUpdateCustomerBilling: json["shouldUpdateCustomerBilling"],
    visibilityReason:
      json["visibilityReason"] == null ? undefined : json["visibilityReason"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
  };
}

export function SelectQuoteInputToJSON(json: any): SelectQuoteInput {
  return SelectQuoteInputToJSONTyped(json, false);
}

export function SelectQuoteInputToJSONTyped(
  value?: SelectQuoteInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shouldSendCancelPickupEmail: value["shouldSendCancelPickupEmail"],
    shouldBookNewPickup: value["shouldBookNewPickup"],
    shouldUpdateCustomerBilling: value["shouldUpdateCustomerBilling"],
    visibilityReason: value["visibilityReason"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
  };
}
